import Loadable from '../../components/Loadable';
import { lazy } from 'react';

const NotFound = Loadable(lazy(() => import('./NotFound')));
const ForgotPassword = Loadable(lazy(() => import('./ForgotPassword')));
const JwtLogin = Loadable(lazy(() => import('./JwtLogin')));
const JwtRegister = Loadable(lazy(() => import('./JwtRegister')));
const ResetPassword = Loadable(lazy(() => import('./ResetPassword')));
const PublicProfile = Loadable(lazy(() => import('./PublicProfile')));
const sessionRoutes = [
  { path: '/session/signup', element: <JwtRegister /> },
  { path: '/session/signin', element: <JwtLogin /> },
  { path: '/session/forgot-password', element: <ForgotPassword /> },
  { path: '/session/404', element: <NotFound /> },
  { path: '/reset-password/:token', element: <ResetPassword /> },
  { path: '/:user_id', element: <PublicProfile /> },
];

export default sessionRoutes;
